import AvatarImage from 'ui/Element/Image/Avatar'
import { Grid } from '@mui/material'
import CellHOC from '@platform/react/hoc/list/cell'

const styles = () => ({
  icon: {
    width: '2.5rem',
    minHeight: '2.5rem',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
})

/**
 * Displays the icon of a part.
 *
 * @param {Object} classes  styles for the component
 * @param {Object} props    props for the component
 * @returns {JSX.Element}
 */
const ListItemCellDashboardArticleIcon = (classes, props = {}) => {
  const { image } = props
  const attachment = image?.attachment?.value?.name
    ? { ...image.attachment, key: image?.value?.attachmentId || image?.id || undefined, api: { ref: 'equipment' } }
    : { value: { name: '' } }

  return (
    <Grid
      item
      xs={'auto'}
      className={classes.icon}
    >
      <AvatarImage
        shape={'circle'}
        attachment={attachment}
        fallbackIcon={{
          name: 'part',
          color: 'text.regular',
          background: 'gray.960',
        }}
      />
    </Grid>
  )
}

export default CellHOC(ListItemCellDashboardArticleIcon, styles)
